import React from "react"
import { checkTileAvailability } from "../js/helpers/tileAvailability.js"

const defaultOptions = { testTileUrl: "https://a.tile.openstreetmap.org/0/0/0.png", timeout: 3000 }
export function withTileAvailability(WrappedComponent, options = defaultOptions) {
  return class extends React.Component {
    state = {
      tilesAvailable: null,
    }

    componentDidMount() {
      checkTileAvailability(options.testTileUrl, options.timeout).then((tilesAvailable) => {
        this.setState({ tilesAvailable })
      })
    }

    render() {
      return <WrappedComponent {...this.props} tilesAvailable={this.state.tilesAvailable} />
    }
  }
}
